import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { AbsColor } from '../../constants';
import { RegulationFetch } from '../../features/regulation.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';
import RegulationCards from '../regulation/regulation-cards.component';
import { Loading } from '../shared';
import TrackerCriteriaResultsFilter from './tracker-criteria-results-filter.component';

const TrackerCriteriaResults = () => {
    const dispatch = useAppDispatch();
    const criteria = useAppSelector((state) => state.Criteria.TrackerCriteria);
    const regulations = useAppSelector((state) => state.Regulation.ByCriteria.Regulations);
    const isLoading = useAppSelector((state) => state.Regulation.ByCriteria.IsLoading);

    // Fetch data only once when the component mounts
    useEffect(() => {
        if (!criteria) return;
        dispatch(RegulationFetch.GetByCriteria(criteria));
    }, [criteria, dispatch]);

    return (
        <Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
            <TrackerCriteriaResultsFilter />
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    {/* Render the paginated data */}
                    {regulations && regulations.length > 0 ? (
                        <>
                            <RegulationCards regulations={regulations} />
                        </>
                    ) : (
                        <Typography variant="h6" color={AbsColor.Blue1}>
                            No results found.
                        </Typography>
                    )}
                </>
            )}
        </Stack>
    );
};

export default TrackerCriteriaResults;
